export interface ReportRequest {
  id: string;
  requested_for: RequestUser;
  requested_by: RequestUser;
  requested_at: string;
  status: string;
}

export interface RequestUser {
  id: string;
  name: string;
}

export interface ReportDto {
  content?: string;
  created_by: string;
  request_id: string;
  data: any;
}

export interface PatientImage {
  id: string;
  image_name: string;
  type: string;
  url: string;
}

export enum ReportStatus {
  DRAFT = 'DRAFT',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED',
  PENDING = 'PENDING'
}
